import React, { Component } from 'react'
import { CommonValidationMessages } from '../../utils/Messages';
import { isValidForm } from '../../utils/validation/CommonValidator';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import SwalServices from '../../services/swalServices/SwalServices';
import { Link } from 'react-router-dom';
import AdminServices from '../../services/axiosServices/apiServices/adminServices';
import { password } from '../../utils/validation/ValidateField';
import ValidationText from '../../utils/validation/ValidationText';
import { set } from 'date-fns';

export default class ForgotPassword extends Component {
    constructor(props) {
        super(props);
        this.swalServices = new SwalServices();
        this.adminServices = new AdminServices();
        this.state = {
            isLoading: false,
            isOtpSent: false,
            emailObject: {
                email: ""
            },
            forgotForm: {
                otp: "",
                password: "",
                confirmPassword: ""
            },
            validationRulesForEmail: {
                email: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "email"
                        ),
                    },
                    {
                        type: "email",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "valid email"
                        ),
                    },
                    {
                        type: "maxLength",
                        maxLength: 50,
                        message: "maximum lenth is 50"
                    },
                    {
                        type: "minLength",
                        minLength: 2,
                        message: "minimum lenth is 2",
                    },
                ],
            },
            validationRuleForOtp: {
                otp: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "otp"
                        ),
                    },
                ],
                password: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "password"
                        ),
                    },
                    {
                        type: "password",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "strong password"
                        ),
                    },
                ],
                confirmPassword: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "confirm password"
                        ),
                    },
                    {
                        type: "compare",
                        message: "password and confirm password should be same",
                        compareEle: "password",
                    },
                ],
            },
            validStateForEmail: {
                isValid: true,
                error: {},
            },
            validStateForOtp: {
                isValid: true,
                error: {},
            },
        };
    }

    isValidAllFieldsForEmail = () => {
        const newValidState = isValidForm(
            this.state.emailObject,
            this.state.validationRulesForEmail,
            this.state.validStateForEmail,
        );
        this.setState({ validStateForEmail: newValidState });
        return newValidState.isValid;
    }

    isValidAllFieldsForOtp = () => {
        const newValidState = isValidForm(
            this.state.forgotForm,
            this.state.validationRuleForOtp,
            this.state.validStateForOtp,
        );
        this.setState({ validStateForOtp: newValidState });
        return newValidState.isValid;
    }

    handleChange = (event, name, section) => {
        let value = event.target.value;
        let details = this.state.emailObject;
        if (section === "emailObject") {
            details[name] = value
            this.setState({ emailObject: details });
        } else if (section === "forgotForm") {
            details[name] = value
            this.setState({ forgotForm: details });
        }
    };

    sendOtp = () => {
        let isValidAllFieldsForEmail = this.isValidAllFieldsForEmail();
        if (isValidAllFieldsForEmail) {
            let request = this.state.emailObject
            this.setState({ isLoading: true });
            this.adminServices.sendOtp(request).then((response) => {
                if (response.success === 1) {
                    this.swalServices.Success(response.msg)
                    this.setState({ isOtpSent: true });
                } else {
                    this.swalServices.Error(response.msg)
                }
                this.setState({ isLoading: false });
            });
        }
    }

    verifyAndUpdatePassword = () => {
        let isValidAllFieldsForOtp = this.isValidAllFieldsForOtp();
        if (isValidAllFieldsForOtp) {
            let request = {}
            request.email = this.state.emailObject.email
            request.otp = this.state.forgotForm.otp
            request.password = this.state.forgotForm.password
            this.setState({ isLoading: true });
            this.adminServices.verifyAndUpdatePassword(request).then((response) => {
                if (response.success === 1) {
                    this.swalServices.Success(response.msg)
                    setTimeout(() => {
                        window.location.href = "/login";
                    }, 1500);
                } else {
                    this.swalServices.Error(response.msg)
                }
                this.setState({ isLoading: false });
            });
        }
    }


    render() {
        return (
            <div className='forgot h-screen'>
                <div className='forgot-inner flex'>
                    <div className='forgot-left h-screen flex flex-col justify-center gap-[50px] px-[120px] w-[45%]'>
                        <div className='forgot-form'>
                            <div className='forgot-logo'>
                                <img src='AHG-logo.svg' alt='Arbour Health Group' />
                            </div>
                            <div className='forgot-sec'>
                                <h1 className='text-[32px] font-medium mb-[10px] text-[#223645] mt-[15px]'>Forgot your password?</h1>
                                <p className='text-[16px] font-medium text-[#223645]'>Enter your email address account to receive an otp.</p>
                                <div className='forgot-form-inner mt-5'>
                                    <div className='form-group'>
                                        <div className='input-grp !mb-[10px]'>
                                            <label>Email Address:</label>
                                            <input type='email' placeholder='Enter your email'
                                                id='email' name='email'
                                                className={`${this.state.validStateForEmail?.error?.email !== undefined ? "error" : ""}`}
                                                value={this.state.emailObject.email}
                                                onChange={(event) => this.handleChange(event, "email", "emailObject")}
                                                disabled={this.state.isOtpSent}
                                            />
                                        </div>
                                        <div className='input-grp !mb-[10px]'>
                                            <label>Enter OTP:</label>
                                            <input type='number' placeholder='Enter otp'
                                                id='otp' name='otp'
                                                className={`${this.state.validStateForOtp?.error?.otp !== undefined ? "error" : ""}`}
                                                value={this.state.forgotForm.otp}
                                                onChange={(event) => this.handleChange(event, "otp", "forgotForm")}
                                                disabled={!this.state.isOtpSent}
                                            />
                                            <ValidationText error={this.state.validStateForOtp.error.otp} />
                                        </div>
                                        {this.state.isOtpSent ?
                                            <>
                                                <div className='input-grp !mb-[10px]'>
                                                    <label>Enter Password:</label>
                                                    <input type='text' placeholder='Enter password'
                                                        id='password' name='password'
                                                        className={`${this.state.validStateForOtp?.error?.password !== undefined ? "error" : ""}`}
                                                        value={this.state.forgotForm.password}
                                                        onChange={(event) => this.handleChange(event, "password", "forgotForm")}
                                                        disabled={!this.state.isOtpSent}
                                                    />
                                                    <ValidationText error={this.state.validStateForOtp.error.password} />
                                                </div>
                                                <div className='input-grp !mb-[10px]'>
                                                    <label>Enter Confirm Password:</label>
                                                    <input type='text' placeholder='Enter confirm password'
                                                        id='confirmPassword' name='confirmPassword'
                                                        className={`${this.state.validStateForOtp?.error?.confirmPassword !== undefined ? "error" : ""}`}
                                                        value={this.state.forgotForm.confirmPassword}
                                                        onChange={(event) => this.handleChange(event, "confirmPassword", "forgotForm")}
                                                        disabled={!this.state.isOtpSent}
                                                    />
                                                    <ValidationText error={this.state.validStateForOtp.error.confirmPassword} />
                                                </div>
                                            </>
                                            : null}
                                    </div>
                                </div>
                                {this.state.isOtpSent ?
                                    <button className='prm-btn btn w-full mt-[20px]' onClick={() => this.verifyAndUpdatePassword()}>Continue</button>
                                    :
                                    <button className='prm-btn btn w-full mt-[20px]' onClick={() => this.sendOtp()}>Send otp</button>
                                }
                                <Link to="/login" className='bg-white border-0 flex justify-center items-center gap-[10px] mt-5'><FontAwesomeIcon icon={faArrowLeft} className='w-5 h-5' />Back to login</Link>
                            </div>
                        </div>
                        <div className='copyright'>
                            <p className='text-[10px] font-medium text-[#64748B] text-center'>Copyright 2025. Arbour Healthcare Group All Rights Reserved.</p>
                        </div>
                    </div>
                    <div className='forgot-right p-[30px] w-[55%] h-fit'>
                        <div className='forgot-right-inner h-screen relative rounded-t-full flex justify-center' style={{ height: "calc(100vh - 60px)" }}>
                            <img src='AHG-logo.svg' alt='Arbour tree' className='w-[100%] h-auto mx-auto' />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}